// source: src/common/signal/relation/relation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_group_group_pb = require('../../../../src/common/group/group_pb.js');
goog.object.extend(proto, src_common_group_group_pb);
var src_common_person_person_pb = require('../../../../src/common/person/person_pb.js');
goog.object.extend(proto, src_common_person_person_pb);
var src_common_opportunity_opportunity_pb = require('../../../../src/common/opportunity/opportunity_pb.js');
goog.object.extend(proto, src_common_opportunity_opportunity_pb);
goog.exportSymbol('proto.loupe.common.signal.relation.Entity', null, global);
goog.exportSymbol('proto.loupe.common.signal.relation.EntityType', null, global);
goog.exportSymbol('proto.loupe.common.signal.relation.Relation', null, global);
goog.exportSymbol('proto.loupe.common.signal.relation.RelationList', null, global);
goog.exportSymbol('proto.loupe.common.signal.relation.RelationType', null, global);
goog.exportSymbol('proto.loupe.common.signal.relation.Relations', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.signal.relation.Entity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.signal.relation.Entity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.signal.relation.Entity.displayName = 'proto.loupe.common.signal.relation.Entity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.signal.relation.Relation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.signal.relation.Relation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.signal.relation.Relation.displayName = 'proto.loupe.common.signal.relation.Relation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.signal.relation.Relations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.signal.relation.Relations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.signal.relation.Relations.displayName = 'proto.loupe.common.signal.relation.Relations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.signal.relation.RelationList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.signal.relation.RelationList.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.signal.relation.RelationList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.signal.relation.RelationList.displayName = 'proto.loupe.common.signal.relation.RelationList';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.signal.relation.Entity.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.signal.relation.Entity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.signal.relation.Entity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.signal.relation.Entity.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    personEntity: (f = msg.getPersonEntity()) && src_common_person_person_pb.Person.toObject(includeInstance, f),
    opportunityEntity: (f = msg.getOpportunityEntity()) && src_common_opportunity_opportunity_pb.Opportunity.toObject(includeInstance, f),
    groupEntity: (f = msg.getGroupEntity()) && src_common_group_group_pb.Group.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.signal.relation.Entity}
 */
proto.loupe.common.signal.relation.Entity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.signal.relation.Entity;
  return proto.loupe.common.signal.relation.Entity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.signal.relation.Entity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.signal.relation.Entity}
 */
proto.loupe.common.signal.relation.Entity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = new src_common_person_person_pb.Person;
      reader.readMessage(value,src_common_person_person_pb.Person.deserializeBinaryFromReader);
      msg.setPersonEntity(value);
      break;
    case 4:
      var value = new src_common_opportunity_opportunity_pb.Opportunity;
      reader.readMessage(value,src_common_opportunity_opportunity_pb.Opportunity.deserializeBinaryFromReader);
      msg.setOpportunityEntity(value);
      break;
    case 5:
      var value = new src_common_group_group_pb.Group;
      reader.readMessage(value,src_common_group_group_pb.Group.deserializeBinaryFromReader);
      msg.setGroupEntity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.signal.relation.Entity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.signal.relation.Entity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.signal.relation.Entity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.signal.relation.Entity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPersonEntity();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      src_common_person_person_pb.Person.serializeBinaryToWriter
    );
  }
  f = message.getOpportunityEntity();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      src_common_opportunity_opportunity_pb.Opportunity.serializeBinaryToWriter
    );
  }
  f = message.getGroupEntity();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      src_common_group_group_pb.Group.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.loupe.common.signal.relation.Entity.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.signal.relation.Entity} returns this
 */
proto.loupe.common.signal.relation.Entity.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.loupe.common.signal.relation.Entity.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.signal.relation.Entity} returns this
 */
proto.loupe.common.signal.relation.Entity.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional loupe.common.person.Person person_entity = 3;
 * @return {?proto.loupe.common.person.Person}
 */
proto.loupe.common.signal.relation.Entity.prototype.getPersonEntity = function() {
  return /** @type{?proto.loupe.common.person.Person} */ (
    jspb.Message.getWrapperField(this, src_common_person_person_pb.Person, 3));
};


/**
 * @param {?proto.loupe.common.person.Person|undefined} value
 * @return {!proto.loupe.common.signal.relation.Entity} returns this
*/
proto.loupe.common.signal.relation.Entity.prototype.setPersonEntity = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.signal.relation.Entity} returns this
 */
proto.loupe.common.signal.relation.Entity.prototype.clearPersonEntity = function() {
  return this.setPersonEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.signal.relation.Entity.prototype.hasPersonEntity = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional loupe.common.opportunity.Opportunity opportunity_entity = 4;
 * @return {?proto.loupe.common.opportunity.Opportunity}
 */
proto.loupe.common.signal.relation.Entity.prototype.getOpportunityEntity = function() {
  return /** @type{?proto.loupe.common.opportunity.Opportunity} */ (
    jspb.Message.getWrapperField(this, src_common_opportunity_opportunity_pb.Opportunity, 4));
};


/**
 * @param {?proto.loupe.common.opportunity.Opportunity|undefined} value
 * @return {!proto.loupe.common.signal.relation.Entity} returns this
*/
proto.loupe.common.signal.relation.Entity.prototype.setOpportunityEntity = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.signal.relation.Entity} returns this
 */
proto.loupe.common.signal.relation.Entity.prototype.clearOpportunityEntity = function() {
  return this.setOpportunityEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.signal.relation.Entity.prototype.hasOpportunityEntity = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional loupe.common.group.Group group_entity = 5;
 * @return {?proto.loupe.common.group.Group}
 */
proto.loupe.common.signal.relation.Entity.prototype.getGroupEntity = function() {
  return /** @type{?proto.loupe.common.group.Group} */ (
    jspb.Message.getWrapperField(this, src_common_group_group_pb.Group, 5));
};


/**
 * @param {?proto.loupe.common.group.Group|undefined} value
 * @return {!proto.loupe.common.signal.relation.Entity} returns this
*/
proto.loupe.common.signal.relation.Entity.prototype.setGroupEntity = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.signal.relation.Entity} returns this
 */
proto.loupe.common.signal.relation.Entity.prototype.clearGroupEntity = function() {
  return this.setGroupEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.signal.relation.Entity.prototype.hasGroupEntity = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.signal.relation.Relation.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.signal.relation.Relation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.signal.relation.Relation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.signal.relation.Relation.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    entity: (f = msg.getEntity()) && proto.loupe.common.signal.relation.Entity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.signal.relation.Relation}
 */
proto.loupe.common.signal.relation.Relation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.signal.relation.Relation;
  return proto.loupe.common.signal.relation.Relation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.signal.relation.Relation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.signal.relation.Relation}
 */
proto.loupe.common.signal.relation.Relation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.loupe.common.signal.relation.Entity;
      reader.readMessage(value,proto.loupe.common.signal.relation.Entity.deserializeBinaryFromReader);
      msg.setEntity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.signal.relation.Relation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.signal.relation.Relation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.signal.relation.Relation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.signal.relation.Relation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEntity();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.loupe.common.signal.relation.Entity.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.loupe.common.signal.relation.Relation.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.signal.relation.Relation} returns this
 */
proto.loupe.common.signal.relation.Relation.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.loupe.common.signal.relation.Relation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.signal.relation.Relation} returns this
 */
proto.loupe.common.signal.relation.Relation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Entity entity = 3;
 * @return {?proto.loupe.common.signal.relation.Entity}
 */
proto.loupe.common.signal.relation.Relation.prototype.getEntity = function() {
  return /** @type{?proto.loupe.common.signal.relation.Entity} */ (
    jspb.Message.getWrapperField(this, proto.loupe.common.signal.relation.Entity, 3));
};


/**
 * @param {?proto.loupe.common.signal.relation.Entity|undefined} value
 * @return {!proto.loupe.common.signal.relation.Relation} returns this
*/
proto.loupe.common.signal.relation.Relation.prototype.setEntity = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.signal.relation.Relation} returns this
 */
proto.loupe.common.signal.relation.Relation.prototype.clearEntity = function() {
  return this.setEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.signal.relation.Relation.prototype.hasEntity = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.signal.relation.Relations.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.signal.relation.Relations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.signal.relation.Relations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.signal.relation.Relations.toObject = function(includeInstance, msg) {
  var f, obj = {
    byTypeMap: (f = msg.getByTypeMap()) ? f.toObject(includeInstance, proto.loupe.common.signal.relation.RelationList.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.signal.relation.Relations}
 */
proto.loupe.common.signal.relation.Relations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.signal.relation.Relations;
  return proto.loupe.common.signal.relation.Relations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.signal.relation.Relations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.signal.relation.Relations}
 */
proto.loupe.common.signal.relation.Relations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getByTypeMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.loupe.common.signal.relation.RelationList.deserializeBinaryFromReader, "", new proto.loupe.common.signal.relation.RelationList());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.signal.relation.Relations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.signal.relation.Relations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.signal.relation.Relations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.signal.relation.Relations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getByTypeMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.loupe.common.signal.relation.RelationList.serializeBinaryToWriter);
  }
};


/**
 * map<string, RelationList> by_type = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.loupe.common.signal.relation.RelationList>}
 */
proto.loupe.common.signal.relation.Relations.prototype.getByTypeMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.loupe.common.signal.relation.RelationList>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.loupe.common.signal.relation.RelationList));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.loupe.common.signal.relation.Relations} returns this
 */
proto.loupe.common.signal.relation.Relations.prototype.clearByTypeMap = function() {
  this.getByTypeMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.signal.relation.RelationList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.signal.relation.RelationList.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.signal.relation.RelationList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.signal.relation.RelationList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.signal.relation.RelationList.toObject = function(includeInstance, msg) {
  var f, obj = {
    relationsList: jspb.Message.toObjectList(msg.getRelationsList(),
    proto.loupe.common.signal.relation.Relation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.signal.relation.RelationList}
 */
proto.loupe.common.signal.relation.RelationList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.signal.relation.RelationList;
  return proto.loupe.common.signal.relation.RelationList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.signal.relation.RelationList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.signal.relation.RelationList}
 */
proto.loupe.common.signal.relation.RelationList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.loupe.common.signal.relation.Relation;
      reader.readMessage(value,proto.loupe.common.signal.relation.Relation.deserializeBinaryFromReader);
      msg.addRelations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.signal.relation.RelationList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.signal.relation.RelationList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.signal.relation.RelationList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.signal.relation.RelationList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRelationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.loupe.common.signal.relation.Relation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Relation relations = 1;
 * @return {!Array<!proto.loupe.common.signal.relation.Relation>}
 */
proto.loupe.common.signal.relation.RelationList.prototype.getRelationsList = function() {
  return /** @type{!Array<!proto.loupe.common.signal.relation.Relation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loupe.common.signal.relation.Relation, 1));
};


/**
 * @param {!Array<!proto.loupe.common.signal.relation.Relation>} value
 * @return {!proto.loupe.common.signal.relation.RelationList} returns this
*/
proto.loupe.common.signal.relation.RelationList.prototype.setRelationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loupe.common.signal.relation.Relation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.signal.relation.Relation}
 */
proto.loupe.common.signal.relation.RelationList.prototype.addRelations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loupe.common.signal.relation.Relation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.signal.relation.RelationList} returns this
 */
proto.loupe.common.signal.relation.RelationList.prototype.clearRelationsList = function() {
  return this.setRelationsList([]);
};


/**
 * @enum {number}
 */
proto.loupe.common.signal.relation.RelationType = {
  TARGET: 0,
  MANAGER: 1,
  OWNER: 2,
  CONTAINS: 3
};

/**
 * @enum {number}
 */
proto.loupe.common.signal.relation.EntityType = {
  PERSON: 0,
  GROUP: 1,
  OPPORTUNITY: 2
};

goog.object.extend(exports, proto.loupe.common.signal.relation);
